import React from 'react';
import { Content } from '~/layouts/Dash/components';


const BasicContent = ({breadcrumb, children}) => {

  const breadcrumbs = [
    {
      label: 'Grupos Usuários',
      to: '/tipo_user',
      active: false,
    },
    breadcrumb,
  ];
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Grupos Usuários"
    >
      {children}
    </Content>
  );
}

export default BasicContent;
